import { useConst } from "@chakra-ui/react";
import { AsyncReturnType } from "type-fest";

import { ReportService } from "@/services";
import { UseQuerySimpleOptions, useQuery } from "@/services/hooks";
import { gen } from "@/utils";

type QueryArgs = Parameters<typeof ReportService.getConnectedReport>[0];
type QueryFnData = AsyncReturnType<typeof ReportService.getConnectedReport>;
type Error = unknown;

const queryKey = (args: QueryArgs) => ["reports", "connected", args];

export const useConnectedReport = <TData = QueryFnData>(
  args: QueryArgs,
  options?: UseQuerySimpleOptions<QueryFnData, Error, TData>
) => {
  const response = useQuery<QueryFnData, Error, TData>(
    queryKey(args),
    () => ReportService.getConnectedReport(args),
    {
      skeletonData: useConst({ report: gen.reports() }),
      ...options,
    }
  );

  return response;
};

useConnectedReport.queryKey = queryKey;
